type Props = {
  className?: string
  width?: number
  height?: number
  color?: string
}

export const UnionIcon = ({ className, width = 28, height = 26, color }: Props) => {
  return (
    <span className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 26" fill="none">
        <path
          d="M4.53809 25.124C2.1239 25.1234 0.166993 19.7132 0.166993 13.04C0.167045 6.36702 2.12393 0.957677 4.53809 0.957029C5.77866 0.957029 6.89768 2.38555 7.69336 4.67969C8.48895 2.38601 9.60635 0.957362 10.8467 0.95703C12.0869 0.95703 13.2053 2.38479 14.001 4.67773C14.7966 2.38478 15.9151 0.95703 17.1553 0.95703C18.3957 0.957323 19.514 2.38581 20.3096 4.67969C21.1053 2.38572 22.2234 0.957031 23.4639 0.957031C25.878 0.9576 27.8349 6.36697 27.835 13.04C27.835 19.7132 25.8781 25.1235 23.4639 25.124C22.2236 25.124 21.1052 23.6956 20.3096 21.4023C19.514 23.6955 18.3955 25.1237 17.1553 25.124C15.9153 25.124 14.7966 23.6965 14.001 21.4043C13.2054 23.6965 12.0866 25.124 10.8467 25.124C9.60657 25.1237 8.48892 23.6953 7.69336 21.4023C6.8977 23.6957 5.77842 25.124 4.53809 25.124Z"
          fill={color ?? 'url(#paint0_linear_union)'}
        />
        <defs>
          <linearGradient
            id="paint0_linear_union"
            x1="5.41667"
            y1="0.290527"
            x2="5.41667"
            y2="23.728"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7ECDA" />
            <stop offset="1" stopColor="#40AD87" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  )
}
